import { EUserType } from "../data_models/enums";
import { IProject } from "../data_models/project";


export const projectTitleMinCharCount = 3;
export const projectSubtitleMinCharCount = 0;

export const projectBriefDescriptionMinCharCount = 50;
export const projectBriefDescriptionMaxCharCount = Infinity;

export const projectDescriptionMinCharCount = 150;
export const projectDescriptionMaxCharCount = Infinity;

export const projectExpectedDeliveryMinCharCount = 10;
export const projectExpectedDeliveryMaxCharCount = Infinity;


export function isProjectTitleValid(title: string) {
    if (title.trim().length >= 3) {
        return true;
    }
    return false;
}

// subtitle is optional
export function isProjectSubtitleValid(subtitle: string) {
    return true;
}


export function isProjectBriefDescriptionValid(briefDescription: string) {
    if (briefDescription.trim().length >= projectBriefDescriptionMinCharCount && briefDescription.trim().length <= projectBriefDescriptionMaxCharCount) {
        return true;
    }
    return false;
}

export function isProjectDescriptionValid(description: string) {
    if (description.trim().length >= projectDescriptionMinCharCount && description.trim().length <= projectDescriptionMaxCharCount) {
        return true;
    }
    return false;
}

export function isProjectExpectedDeliveryValid(expectedDelivery: string) {
    if (expectedDelivery.trim().length > projectExpectedDeliveryMinCharCount && expectedDelivery.trim().length <= projectExpectedDeliveryMaxCharCount) {
        return true;
    }
    return false;
}

// at least 1 skill is required
export function isProjectSkillsValid(skills: string[]) {
    if (skills.length > 0) {
        return true;
    }
    return false;
}

// tools are not required
export function isProjectToolsValid(tools: string[]) {
    if (tools.length >= 0) {
        return true;
    }
    return false;
}

// sort projects by created at date
export const sortByCreatedAt = (projects: IProject[]) => {
    return projects.sort((a, b) => {
        if (!a._createdAt || !b._createdAt) return 0;
        if (a._createdAt && b._createdAt && a._createdAt > b._createdAt) {
            return -1;
        }
        if (a._createdAt < b._createdAt) {
            return 1;
        }
        return 0;
    });
}

// either is employer or project manager
export const userHasEditProjectDetailsPermissions = (project: IProject, userId: string, userType: EUserType): boolean => {
    return userIsEmployer(project, userId, userType) || userIsProjectManager(project, userId, userType);
}

export const userIsEmployer = (project: IProject, userId?: string, userType?: EUserType): boolean => {
    if (!project || !userId) return false;
    return userType === EUserType.EMPLOYER && project.employerId === userId;
}

export const userIsProjectManager = (project: IProject, userId?: string, userType?: EUserType): boolean => {
    if (!project || !userId) return false;
    return userType === EUserType.FREELANCER && project.currentProjectManager === userId;
}

export const userIsRoadmapVerificationProjectManager = (project: IProject, userId?: string, userType?: EUserType): boolean => {
    if (!project || !userId) return false;
    return userType === EUserType.FREELANCER && project.currentRoadmapVerificationPm === userId;
}

export const userIsParticipatingFreelancer = (project: IProject, userId?: string, userType?: EUserType): boolean => {
    if (!project || !userId) return false;
    return userType === EUserType.FREELANCER && project.assignedFreelancers?.find(freelancer => freelancer.freelancerId === userId) !== undefined;
}